import { render, staticRenderFns } from "./PunchImport.vue?vue&type=template&id=1b43b25c&scoped=true&"
import script from "./PunchImport.vue?vue&type=script&lang=js&"
export * from "./PunchImport.vue?vue&type=script&lang=js&"
import style0 from "./PunchImport.vue?vue&type=style&index=0&id=1b43b25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43b25c",
  null
  
)

export default component.exports